import './map.scss';
import extraAttribution from './attribution.html';

mapboxgl.accessToken = 'pk.eyJ1IjoiZm91bmRyeXNwYXRpYWwiLCJhIjoiNzk1YTU3OTZmMjZiMzQ3YzM5YzIwODNiNjhkM2MzMDQifQ.sfy6Aux5O-BBqbSVNaec1A';

// restrict panning to Canada
let canadaBounds = [
    [
        -165.9375,
        15.284185114076445
    ],
    [
        -30.937499999999996,
        84.40594104126978
    ],
];

// initialize map
let map = new mapboxgl.Map({
    container: 'map', // container id
    style: 'mapbox://styles/foundryspatial/cimm7gkys00dsypnhlgvjly5h', //hosted style id
    center: [-103.095703125, 56.84897198026975], // starting position
    zoom: 2, // starting zoom
    minZoom: 2,
    maxZoom: 15,
    maxBounds: canadaBounds,
});

// disable rotation
map.dragRotate.disable();
map.touchZoomRotate.disableRotation();

// add map controls
map.addControl(new mapboxgl.Navigation({position: 'top-left'}));
// geocoder
map.addControl(new mapboxgl.Geocoder({
    country: 'ca',
    types: 'region,postcode,place,locality,address'
}));

// append NRCan & Foundry Spatial attribution
map.once('load', function(){
    let attributionElement = document.querySelector('.mapboxgl-ctrl-attrib');
    attributionElement.insertAdjacentHTML('beforeend', extraAttribution);
});

export default map;


// WEBPACK FOOTER //
// ./src/js/map/map.js